"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTomourResearch = createTomourResearch;
const events_1 = require("../../../events");
const shared_1 = require("../../shared");
const messages_1 = require("./messages");
const queries_1 = require("../queries");
const messages = {
    screeningProcedures: {
        id: "ktx.dashboard.tomour_research",
        defaultMessage: "Góc és Tumorkutatás"
    }
};
var ScreeningProcedureResult;
(function (ScreeningProcedureResult) {
    ScreeningProcedureResult["NORMAL"] = "NORMAL";
    ScreeningProcedureResult["ABNORMAL"] = "ABNORMAL";
})(ScreeningProcedureResult || (ScreeningProcedureResult = {}));
const groups = [
    {
        label: messages_1.messages.abnormal,
        variant: "dark",
        predicate: (event) => event !== undefined &&
            event.value.result === ScreeningProcedureResult.ABNORMAL
    },
    {
        label: messages_1.messages.normal,
        variant: "light",
        predicate: (event) => event !== undefined &&
            event.value.result === ScreeningProcedureResult.NORMAL
    }
];
const values = Object.values(queries_1.tomourResearchQueries).map(query => ({
    query,
    label: shared_1.fsnMessages[(0, events_1.mapInterpretationToString)(query.interpretation)]
}));
function createTomourResearch(intl, { events }) {
    const list = (0, shared_1.createGroupList)(intl, { events, groups, values });
    const content = (0, shared_1.createSectionContent)([list]);
    return (0, shared_1.createSection)(intl, {
        label: messages.screeningProcedures,
        content
    });
}
